var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineCcLogoNegro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OutlineCCLogo_Negro",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500.335,
    height: 117.572,
    viewBox: "0 0 500.335 117.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M377.787,306.052c24.466,0,41.292,16.368,41.292,39.809,0,23.554-16.825,39.922-41.292,39.922-24.581,0-41.52-16.425-41.52-39.979C336.267,322.364,353.206,306.052,377.787,306.052Zm.114,59.485c10.893,0,18.136-7.984,18.136-19.676,0-11.521-7.243-19.391-18.136-19.391-11.122,0-18.593,7.87-18.593,19.391C359.308,357.553,366.779,365.537,377.9,365.537Z",
    transform: "translate(-336.267 -306.052)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M426.486,307.166h22.072v46.995c0,8.155,7.129,12.262,14.03,12.262,7.358,0,14.087-4.449,14.087-12.262V307.166h22.072v48.592c0,20.759-18.136,30-36.159,30-19.5,0-36.1-9.981-36.1-30Z",
    transform: "translate(-334.075 -306.025)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M526.917,325.759H504.844V307.166h67.469v18.593H549.673v58.857H526.917Z",
    transform: "translate(-332.171 -306.025)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M638.8,384.616H578.86v-77.45h22.756v59.313H638.8Z",
    transform: "translate(-330.372 -306.025)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M668.392,384.616H645.636v-77.45h22.756Z",
    transform: "translate(-328.75 -306.025)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M701.854,384.616H679.726v-77.45h18.536l35.3,41.348V307.166h22.128v77.45H737.955l-36.1-40.892Z",
    transform: "translate(-327.921 -306.025)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M826.166,384.616h-60.4v-77.45H825.88v18.251H788.525v10.892h33.592v18.136H788.525v12.034h37.641Z",
    transform: "translate(-325.831 -306.025)",
    fill: "#1c1a24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(4.387 101.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M349.822,405.135a12.1,12.1,0,0,1,4.854.966l-.321,3.923a9.394,9.394,0,0,0-4.1-.909c-2.612,0-5.016,1.081-5.016,4,0,2.819,2.37,4.118,4.992,4.118a7.347,7.347,0,0,0,4.119-1.219l.7,3.865a11.114,11.114,0,0,1-5.764,1.335c-4.808,0-8.73-3.117-8.742-8.041C340.55,407.8,344.864,405.146,349.822,405.135Z",
    transform: "translate(-340.55 -405.135)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M376.817,405.135c4.935,0,8.329,3.3,8.329,8.029,0,4.751-3.393,8.052-8.329,8.052-4.958,0-8.375-3.313-8.375-8.063C368.442,408.425,371.859,405.135,376.817,405.135Zm.023,12c2.2,0,3.658-1.611,3.658-3.969a3.592,3.592,0,0,0-3.658-3.912,3.945,3.945,0,0,0,0,7.881Z",
    transform: "translate(-339.872 -405.135)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M408.132,417.092l-4.313-4.808v8.7h-4.464V405.359h3.7l5.3,6.109,5.28-6.109h3.715v15.622h-4.475V412.3l-4.256,4.8Z",
    transform: "translate(-339.121 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M431.908,405.359h4.452v9.479a2.862,2.862,0,0,0,5.671,0v-9.479h4.452v9.8c0,4.187-3.659,6.05-7.293,6.05-3.934,0-7.282-2.013-7.282-6.05Z",
    transform: "translate(-338.33 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M465.577,420.981h-4.463V405.359h3.739l7.12,8.341v-8.341h4.464v15.622h-3.578l-7.282-8.247Z",
    transform: "translate(-337.62 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M495.707,420.981h-4.59V405.359h4.59Z",
    transform: "translate(-336.891 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M517.786,405.359c5.085,0,8.144,2.636,8.144,7.754,0,5.142-3.037,7.868-8.144,7.868h-7.143V405.359Zm3.486,7.754c0-2.726-1.427-4-3.751-4h-2.358v8.144h2.358C519.949,417.254,521.272,415.679,521.272,413.113Z",
    transform: "translate(-336.417 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M550.567,418.371h-5.659l-1,2.61h-4.9l6.006-15.622h5.475l5.993,15.622h-4.9Zm-4.612-3.463h3.577l-1.782-5.223Z",
    transform: "translate(-335.728 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M577.422,405.359c5.085,0,8.145,2.636,8.145,7.754,0,5.142-3.037,7.868-8.145,7.868h-7.144V405.359Zm3.486,7.754c0-2.726-1.426-4-3.75-4H574.8v8.144h2.358C579.585,417.254,580.907,415.679,580.907,413.113Z",
    transform: "translate(-334.968 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M627.653,405.135a12.1,12.1,0,0,1,4.854.966l-.323,3.923a9.384,9.384,0,0,0-4.095-.909c-2.611,0-5.015,1.081-5.015,4,0,2.819,2.369,4.118,4.992,4.118a7.343,7.343,0,0,0,4.118-1.219l.7,3.865a11.108,11.108,0,0,1-5.763,1.335c-4.808,0-8.731-3.117-8.742-8.041C618.381,407.8,622.694,405.146,627.653,405.135Z",
    transform: "translate(-333.799 -405.135)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M656.608,420.981l-3.036-4.244h-2v4.244h-4.555V405.359h7.915c3.9,0,6.085,2.474,6.085,5.626a5.238,5.238,0,0,1-2.83,4.773l3.865,5.222Zm-5.039-11.813v3.842h2.577c1.346,0,2.208-.667,2.208-1.933,0-1.311-.816-1.909-2.208-1.909Z",
    transform: "translate(-333.103 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M688.268,420.981H676.085V405.359h12.124v3.681h-7.535v2.2h6.776V414.9h-6.776v2.426h7.593Z",
    transform: "translate(-332.397 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M713.314,418.371h-5.659l-1,2.61h-4.9l6.005-15.622h5.475l5.993,15.622h-4.9Zm-4.612-3.463h3.577l-1.782-5.223Z",
    transform: "translate(-331.773 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M735.075,409.11h-4.452v-3.751h13.608v3.751h-4.566v11.871h-4.59Z",
    transform: "translate(-331.072 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M762.79,420.981H758.2V405.359h4.59Z",
    transform: "translate(-330.402 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M789.018,405.359h5.051l-5.441,15.622h-6.212l-5.487-15.622h5.05l3.543,11.2Z",
    transform: "translate(-329.947 -405.13)",
    fill: "#1c1a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M817.515,418.371h-5.659l-1,2.61h-4.9l6-15.622h5.476l5.993,15.622h-4.9Zm-4.612-3.463h3.577l-1.782-5.223Z",
    transform: "translate(-329.241 -405.13)",
    fill: "#1c1a24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCcLogoNegro);
export default __webpack_public_path__ + "static/media/OutlineCCLogo_Negro.c22aeab0da64613dd7f35ae946f22068.svg";
export { ForwardRef as ReactComponent };